/*
 * @Author: Teemo Ding
 * @Date: 2021-05-27 08:53:37
 * @LastEditors: Teemo Ding
 * @LastEditTime: 2021-06-08 13:53:20
 * @FilePath: /unifyxp-v2-store-portal/src/components/Card/ImageCard/index.tsx
 */

import React from 'react';
import css from './css.less';

import { Card, DropDown } from '@/src/components/Antd';
import Menu from '@/src/components/Antd/Menu/Menu';
import MenuItem from '@/src/components/Antd/Menu/MenuItem/MenuItem/Menu';
import { Icon } from '@/src/tools/icon';

const ImageCard = ({
  title,
  className,
  uuid,
  num,
  imageUrl,
  overlayMenu,
  onClick,
}) => {
  const overlay = React.useMemo(
    () => (
      <div className={css.menu}>
        <Menu>
          {(overlayMenu || []).map((item, index) => (
            <MenuItem
              key={item.key}
              data-item-id={`${item.id}_${index}`}
              style={{ color: item.color }}
              className={!item.function && 'ant-menu-item-disabled'}
              onClick={(e) => {
                console.log(e.domEvent, 'eeeeee');
                e.domEvent.stopPropagation();
                if (item.function) item.function(uuid);
              }}>
              {item.value}
            </MenuItem>
          ))}
        </Menu>
      </div>
    ),
    [overlayMenu],
  );
  return (
    <Card
      hoverable
      className={`${className} ${css.card}`}
      onClick={(e) => onClick(e)}
      bodyStyle={{ height: 100, padding: '16px 16px 12px 16px' }}
      cover={<img alt='example' src={imageUrl} />}>
      <div className={css.description}>
        <div className={css.top}>
          <div className={css.title}>{title}</div>
          {overlayMenu && (
            <DropDown
              overlay={overlay}
              placement='bottomRight'
              getPopupContainer={(triggerNode) => triggerNode.parentElement}
              trigger={['click']}>
              <Icon
                type='iconMore'
                className={css.moreIcon}
                onClick={(e) => e.stopPropagation()}
              />
            </DropDown>
          )}
        </div>
        <div className={css.bottom}>
          <Icon type='iconproducts' onClick={(e) => e.preventDefault()} />
          {num}
        </div>
      </div>
    </Card>
  );
};

export default ImageCard;
